<ng-container *transloco="let t">

  <div class="p-grid">
    <div class="p-col">
      <h2 *ngIf="type">{{ t('reportings.headers.' + type) }}</h2>
    </div>
    <div class="p-col p-text-right">
      <button pButton (click)="loadData()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button *ngIf="loading !== true" pButton (click)="loadExport()" type="button" icon="pi pi-file-excel" class="p-mb-2 p-ml-2" aria-label="{{ t('common.labels.export') }}" [label]="t('common.labels.export')"></button>
    </div>
  </div>

  <app-loader [loading]="loading"></app-loader>

  <div *ngIf="loading !== true && entries?.length > 0" class="p-mt-4">
    <p-table #dt [columns]="columns" [value]="entries" [paginator]="true" [rows]="20" responsiveLayout="scroll" (onFilter)="onFilter($event, dt)" stateStorage="local" [stateKey]="'reporting_' + type">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.hidden !== true && col.sort !== true" [ngClass]="col.class">
              {{ t('reportings.labels.' + col.name) }}
            </th>
            <th *ngIf="col.hidden !== true && col.sort === true" [pSortableColumn]="col.name" [ngClass]="col.class">
              {{ t('reportings.labels.' + col.name) }} <p-sortIcon [field]="col.name"></p-sortIcon>
            </th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th *ngIf="col.hidden !== true">
              <ng-container *ngIf="col.filter" [ngSwitch]="col.filter">
                <ng-container *ngSwitchCase="'date'">
                  <span *ngIf="dateFilterValues[col.name]?.start" class="date-filter-value">&gt;&nbsp;{{ dateFilterValues[col.name].start | amDateFormat: 'DD.MM.YYYY' }}<br></span>
                  <span *ngIf="dateFilterValues[col.name]?.end" class="date-filter-value">&lt;&nbsp;{{ dateFilterValues[col.name].end | amDateFormat: 'DD.MM.YYYY' }}<br></span>
                  <button type="button" (click)="showDateSelector(col.name)" class="p-column-filter-clear-button p-link"><span class="pi pi-filter"></span></button>
                  <button *ngIf="dateFilterValues[col.name]" type="button" (click)="clearPeriod(col.name)" class="p-column-filter-clear-button p-link"><span class="pi pi-filter-slash"></span></button>
                </ng-container>
                <p-columnFilter *ngSwitchDefault [type]="col.filter" [field]="col.name" [matchMode]="'contains'"></p-columnFilter>
              </ng-container>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entry let-columns="columns">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td *ngIf="col.hidden !== true" [ngClass]="col.class">
              <ng-container [ngSwitch]="col.format">
                <ng-container *ngSwitchCase="'date'">{{ entry[col.name] | amDateFormat: 'DD.MM.YYYY' | dashWhenEmpty }}</ng-container>
                <ng-container *ngSwitchDefault>
                  <span *ngIf="col.hyperlink === true && entry.hyperlink !== null"><a [attr.href]="entry.hyperlink" target="_blank">{{ entry[col.name] | dashWhenEmpty }}</a></span>
                  <span *ngIf="col.hyperlink !== true">{{ entry[col.name] | dashWhenEmpty }}</span>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="loading !== true && (!entries || entries?.length === 0)">
    <p class="p-text-center p-mt-4 p-mb-4">
      <i class="pi pi-exclamation-triangle big-icon"></i><br>
      {{ t('reportings.labels.no_data') }}
    </p>
  </div>

  <app-reporting-date-selector [(visible)]="dateSelectorVisible" [field]="dateSelectorField" (periodSelected)="filterPeriod($event)"></app-reporting-date-selector>

</ng-container>
